// extracted by mini-css-extract-plugin
export default {"li":"ProductCard_li__EgJ7T","img":"ProductCard_img__M8sOj","div":"ProductCard_div__JYYzz","h3":"ProductCard_h3__yRcDo","divP":"ProductCard_divP__z9aj6","p":"ProductCard_p__iIKoC"};